import { render } from "./CreatePost.vue?vue&type=template&id=cc1398f0&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"

import "./create-post.scss?vue&type=style&index=0&id=cc1398f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1398f0"]])

export default __exports__